import * as Cesium from 'cesium';
import BaseLayer from "./baseLayer";
import CONSTANTS from "../constants";
/**
 *轨迹图层
 */
export default class TrackLayer extends BaseLayer{

    constructor(options= {}){
        options.layerName=options.layerName||CONSTANTS.LAYER.TRACK;//图层名
        super(options);
    }

    addEntities(data){
        let self=this;
        self.clearLayer();
        let positions=[];
        data.forEach((lnglat,index) =>{
            positions.push(Cesium.Cartesian3.fromDegrees(lnglat[0],lnglat[1], CONSTANTS.ALTITUDE));
            if(index===0){//起点
                let entity=new Cesium.Entity({
                    position: Cesium.Cartesian3.fromDegrees(lnglat[0],lnglat[1], CONSTANTS.ALTITUDE),
                    attributes: {
                        layerName:self.layerName
                    },
                    //立广告牌
                    billboard :{
                        image : "/static/imgs/map/startPoint.png",
                        show : true,
                        width : 48,
                        height : 48,
                        pixelOffset:new Cesium.Cartesian2(-10, 0),
                        heightReference:Cesium.HeightReference.CLAMP_TO_GROUND
                    }
                });
                self.dataSource.entities.add(entity);
            }
            if(index===data.length-1){//终点
                let entity=new Cesium.Entity({
                    position: Cesium.Cartesian3.fromDegrees(lnglat[0],lnglat[1], CONSTANTS.ALTITUDE),
                    attributes: {
                        layerName:self.layerName
                    },
                    //立广告牌
                    billboard :{
                        image : "/static/imgs/map/endPoint.png",
                        show : true,
                        width : 48,
                        height : 48,
                        pixelOffset:new Cesium.Cartesian2(-10, 0),
                        heightReference:Cesium.HeightReference.CLAMP_TO_GROUND
                    }
                });
                self.dataSource.entities.add(entity);
            }
        });

        let entity =new Cesium.Entity({
            id: "track",
            show:true,
            attributes:{
                layerName:self.layerName
            },
            polyline:new Cesium.PolylineGraphics ({
                show:true,
                positions:positions,
                clampToGround: false,
                width:6,//轨迹线宽
                material: new Cesium.PolylineArrowMaterialProperty(Cesium.Color.fromCssColorString("green"))

            } )
        });
        self.dataSource.entities.add(entity);

    }
}
